const adminLibraryRoutes = [
    { path: 'library/helps', component: () => import('pages/sot.bot.admin/helps20/Helps20Index.vue') }, // Справки,
    { path: 'library/skills', component: () => import('pages/sot.bot.admin/skills/SkillsIndex.vue') }, // Компетенции
    { path: 'library/dictionaries', name: 'dictionaries', component: () => import('pages/sot.bot.admin/dictionaries/DictionariesPage.vue') }, // Словари
    {
        name: 'site-tab',
        path: 'library/site/:tab',
        component: () => import('pages/sot.bot.admin/site/SiteIndex.vue'),
    },
    { path: 'library/documents-templates', component: () => import('pages/sot.bot.admin/docTemplates20/DocTemplates20Index.vue') },
    { path: 'library/media-service', component: () => import('pages/sot.bot.admin/library/MediaService.vue') }, // медиасервис,
    { path: 'library/links', component: () => import('pages/sot.bot.admin/links20/Links20Index.vue') }, // ссылки,
    { path: 'library/templates', component: () => import('pages/sot.bot.admin/templatesSettings/TemplatesSettings.vue') },
    { path: 'library/recommendations', component: () => import('pages/sot.bot.admin/library/recommendations/RecommendationsIndex.vue') }, // Рекомендации
    { path: 'library/event-materials', component: () => import('pages/sot.bot.admin/eventMaterials/EventMaterialsIndex.vue') }, // Материалы
];

export default adminLibraryRoutes;
